import store from '@/store';
import constant from "../../constant";

/**
 * Options defined as vanilla object until we can support TypeScript interfaces.
 */
export const UseMonitorSnapshotOptions = {
    // Callback invoked when a photo is captured and saved
    onCapture: null,
    // A string indicating the image format
    mime: 'image/png',
    // A Number between 0 and 1 indicating the image quality to be used when capturing photos
    quality: 1,
    // The captured image output, either base64 or blob
    output: 'base64',
}

export function useMonitorSnapshot(video, canvas, options) {
    options = {...UseMonitorSnapshotOptions, ...options};

    async function submitImage(type, data, log_event_id=null) {
            const event = {
                type: type,
                data: data,
                base_64: options.output === 'base64',
            };
            if(type == 'in-progress'){
                event.page = store.getters.getCurrentTestPageNumber;
                event.question_id= store.getters['Test/getVisibleQuestions'][0]
            }
            return await store.dispatch('Monitoring/submitImage', {image_data: event, event_id: log_event_id}, null);

    }


    function snapshot() {
        canvas.value.width = constant.VIDEO_FEED_DEFAULT_VIDEO_HEIGHT;
        canvas.value.height = constant.VIDEO_FEED_DEFAULT_VIDEO_HEIGHT;

        const context = canvas.value.getContext('2d');
        context?.clearRect(0, 0, canvas.value.width, canvas.value.height);

        const videoWidth = video.value.videoWidth;
        const videoHeight = video.value.videoHeight;
        const cropSize = Math.min(videoWidth, videoHeight); // determine the smaller dimension : 480px

        const xOffset = (videoWidth - cropSize) / 2 ; // (640 - 480) /2 = 80
        const yOffset = (videoHeight - cropSize) / 2; // (480 - 480) /2 = 0



        context?.drawImage(video.value,
            xOffset, yOffset, cropSize, cropSize,
            0, 0, canvas.value.width, canvas.value.height
        );

        return canvas.value;
    }

    async function captureAsBlob() {
        return new Promise((resolve, reject) => {
            try {
                snapshot().toBlob(blob => resolve(blob), options.mime, options.quality);
            } catch (error) {
                reject(error);
            }
        });
    }

    async function captureAsBase64() {
        return new Promise((resolve, reject) => {
            try {
                resolve(snapshot().toDataURL(options.mime, options.quality));
            } catch (error) {
                reject(error);
            }
        });
    }

    async function capture() {
        const output = {blob: captureAsBlob, base64: captureAsBase64};
        const type = options.output === 'blob' ? 'blob' : 'base64';
        const image = await output[type]();

        return new Promise((resolve, reject) => {
            try {
                options.onCapture?.(image);
                resolve(image);
            } catch (error) {
                resolve();
            }
        });
    }

    return {
        capture,
        submitImage,

    }
}
